import { forwardRef, HTMLAttributes } from 'react'
import { Slot } from '@radix-ui/react-slot'

import { cn } from '@/lib/utils'

export type SectionProps = HTMLAttributes<HTMLElement> & {
  asChild?: boolean
}

const Section = forwardRef<HTMLElement, SectionProps>(
  ({ asChild, className, ...props }, ref) => {
    const Component = asChild ? Slot : 'section'

    return (
      <Component
        ref={ref}
        className={cn(
          'relative h-auto w-full lg:h-full lg:w-auto lg:shrink-0 lg:grow-0',
          className
        )}
        {...props}
      />
    )
  }
)

export default Section
